import ApiRequest from "../utils/ApiRequest";
// import GlobalData from "../util/GlobalData";

export default class Help {
    getAll = async () => {
        return await ApiRequest.set(`/v1/help-center/list-help-center`, "GET");
    }
}